// // src/hooks/useGroupedRegionData.js
// import { useEffect, useState, useCallback } from 'react';
// import axios from 'axios';
// import { Admin_Regions_API } from '../../../../constants';
// import PropTypes from 'prop-types';

// // PropTypes for assignment object

// const useGroupedRegionData = (search = '', regionId = '') => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const fetchData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res = await axios.get(Admin_Regions_API);
//       if (res.data.success) {
//         const raw = res.data.data;

//         // Filter assignments
//         const filtered = raw.filter((a) => {
//           const matchSearch =
//             a.EmployeeName.toLowerCase().includes(search.toLowerCase()) ||
//             a.EmployeeId.includes(search);
//           const matchRegion = regionId ? a.RegionId === regionId : true;
//           return matchSearch && matchRegion;
//         });

//         // Group by EmployeeId
//         const map = new Map();
//         for (const row of filtered) {
//           if (!map.has(row.EmployeeId)) {
//             map.set(row.EmployeeId, {
//               EmployeeId: row.EmployeeId,
//               EmployeeName: row.EmployeeName,
//               assignments: [],
//             });
//           }
//           map.get(row.EmployeeId).assignments.push(row);
//         }
//         setData(Array.from(map.values()));
//       } else {
//         setData([]);
//       }
//     } catch (err) {
//       console.error('Failed to fetch regions data', err);
//       setData([]);
//     } finally {
//       setLoading(false);
//     }
//   }, [search, regionId]);

//   useEffect(() => {
//     fetchData();
//   }, [fetchData]);

//   return { data, loading, refetch: fetchData };
// };

// export default useGroupedRegionData;

// src/hooks/useGroupedRegionData.jsx
import { useEffect, useState, useCallback } from 'react';
import axiosInstance from 'axios';
import { Admin_Regions_API } from '../../../../constants';

const useGroupedRegionData = (search, regionId) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get(`${Admin_Regions_API}`);
      if (res.data.success) {
        const raw = res.data.data;

        // Filter
        const filtered = raw.filter((a) => {
          const matchSearch =
            a.EmployeeName.toLowerCase().includes(search.toLowerCase()) ||
            a.EmployeeId.includes(search);
          const matchRegion = regionId ? a.RegionId === regionId : true;
          return matchSearch && matchRegion;
        });

        // Group by EmployeeId
        const map = new Map();

        for (const row of filtered) {
          if (!map.has(row.EmployeeId)) {
            map.set(row.EmployeeId, {
              EmployeeId: row.EmployeeId,
              EmployeeName: row.EmployeeName,
              assignments: [],
            });
          }
          map.get(row.EmployeeId).assignments.push(row);
        }

        setData(Array.from(map.values()));
      }
    } catch (err) {
      console.error('Failed to fetch regions data', err);
    } finally {
      setLoading(false);
    }
  }, [search, regionId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, refetch: fetchData };
};

export default useGroupedRegionData;
